import { useState, type FormEvent } from "react";
import type { MeResponse } from "@guestbook/shared";
import { Button } from "@/shared/components/ui/Button";
import { FormField } from "@/shared/components/form/FormField";
import { useUpdateProfile } from "@/shared/lib/auth";

/**
 * Edit the account display name. No password required — this is a
 * non-sensitive change. An empty value clears the name (stored as null).
 */
export function ProfileNameForm({ user }: { user: MeResponse }) {
  const update = useUpdateProfile();
  const [name, setName] = useState(user.name ?? "");

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const trimmed = name.trim();
    update.mutate({ name: trimmed ? trimmed : null });
  }

  return (
    <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
      <FormField
        label="Name"
        name="name"
        autoComplete="name"
        value={name}
        onChange={(e) => {
          setName(e.target.value);
          update.reset();
        }}
        hint="Shown on your account. Leave blank to remove it."
      />
      {update.error ? (
        <p className="type-body-sm text-danger-strong mx-4">{update.error.message}</p>
      ) : update.isSuccess ? (
        <p className="type-body-sm text-text-muted mx-4">Name updated.</p>
      ) : null}
      <div className="flex justify-end">
        <Button type="submit" disabled={update.isPending}>
          {update.isPending ? "Saving…" : "Save name"}
        </Button>
      </div>
    </form>
  );
}
